import { render, staticRenderFns } from "./PackageDefaultKids.vue?vue&type=template&id=2e5bf680&scoped=true"
import script from "./PackageDefaultKids.vue?vue&type=script&lang=js"
export * from "./PackageDefaultKids.vue?vue&type=script&lang=js"
import style0 from "./PackageDefaultKids.vue?vue&type=style&index=0&id=2e5bf680&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5bf680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5bf680')) {
      api.createRecord('2e5bf680', component.options)
    } else {
      api.reload('2e5bf680', component.options)
    }
    module.hot.accept("./PackageDefaultKids.vue?vue&type=template&id=2e5bf680&scoped=true", function () {
      api.rerender('2e5bf680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageDefaultKids.vue"
export default component.exports